var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2736_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 24L11.9935 23.9988H11.9742C8.13135 23.9988 5.67613 22.1708 5.43459 22.0652L0.905765 23.2479L2.11949 18.8265L1.83085 18.3716C0.635243 16.4599 0 14.2583 0 11.9911C0 1.32509 12.9766 -4.00854 20.486 3.53035C27.9773 10.9904 22.7178 24 12.0008 24Z",
    fill: "#29A71A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.507 14.3072L17.498 14.3822C17.197 14.2322 15.731 13.5152 15.458 13.4162C14.845 13.1892 15.018 13.3802 13.841 14.7282C13.666 14.9232 13.492 14.9382 13.195 14.8032C12.895 14.6532 11.932 14.3382 10.792 13.3182C9.90402 12.5232 9.30802 11.5482 9.13202 11.2482C8.83902 10.7422 9.45202 10.6702 10.01 9.61417C10.11 9.40417 10.059 9.23917 9.98502 9.09017C9.91002 8.94017 9.31302 7.47017 9.06302 6.88417C8.82302 6.30017 8.57602 6.37417 8.39102 6.37417C7.81502 6.32417 7.39402 6.33217 7.02302 6.71817C5.40902 8.49217 5.81602 10.3222 7.19702 12.2682C9.91102 15.8202 11.357 16.4742 14.001 17.3822C14.715 17.6092 15.366 17.5772 15.881 17.5032C16.455 17.4122 17.648 16.7822 17.897 16.0772C18.152 15.3722 18.152 14.7872 18.077 14.6522C18.003 14.5172 17.807 14.4422 17.507 14.3072Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2736_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.860a93b45d8618ae24a94c087dfbb774.svg";
export { ForwardRef as ReactComponent };